export function PageHeader({ title, subtitle, testId }) {
  return (
    <div className="max-w-7xl mx-auto px-4 pt-14 pb-10 text-center" data-testid={testId || "page-header"}>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight">{title}</h1>
      {subtitle && <p className="mt-4 text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">{subtitle}</p>}
      <div className="mt-6 mx-auto h-px w-16 bg-primary/40" />
    </div>
  );
}
